import { render, staticRenderFns } from "./keyset_pagination.vue?vue&type=template&id=311ba542"
import script from "./keyset_pagination.vue?vue&type=script&lang=js"
export * from "./keyset_pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports